import * as React from 'react';
import { faCaretLeft } from '@fortawesome/pro-solid-svg-icons/faCaretLeft';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';

type Props = {
    className?: string;
    label: string;
    target?: string;
    type: string;
};

const BackBreadcrumb = (props: Props) => {
    const history = useHistory();
    const { className = '', label = '', target = '', type = 'label' } = props;

    const handleGoBackClick = React.useCallback(() => {
        history.goBack();
    }, [history]);

    return (
        <StyledBackBreadcrumb className={className}>
            <StyledCaretIcon icon={faCaretLeft} />
            {type === 'back' && (
                <StyledBigBreadcrumb onClick={handleGoBackClick} secondary>
                    {label}
                </StyledBigBreadcrumb>
            )}
            {type === 'link' && (
                <StyledBigBreadcrumb route secondary to={target}>
                    {label}
                </StyledBigBreadcrumb>
            )}
        </StyledBackBreadcrumb>
    );
};

export default React.memo<Props>(BackBreadcrumb);

const StyledBackBreadcrumb = styled.li`
    margin: 0 12px 0 0;
    display: inline-block;
    vertical-align: middle;
    border-right: 1px solid ${({ theme }) => theme.colors.grey100};
    cursor: pointer;
`;

const StyledBigBreadcrumb = styled(Link)`
    && {
        margin: 0 12px 0 8px;
        font-size: 13px;
        font-family: ${({ theme }) => theme.typography.fontPrimaryStrong};
        line-height: 16px;
        display: inline-block;
        border-bottom: 1px solid ${({ theme }) => theme.colors.grey100};
        transition: border-bottom 0.3s, color 0.3s;
        text-decoration: none;
        cursor: pointer;

        &:hover {
            border-bottom: 1px solid ${({ theme }) => theme.colors.blue200};
        }
    }
`;

const StyledCaretIcon = styled(FontAwesomeIcon)`
    color: ${({ theme }) => theme.colors.grey100};
    height: 13px;
    width: 10px;
`;
